export enum TipoProduto {
    TIPO_PRODUTO_CODIGO = "curso_padrao",
}
